import type { IPropsMarker } from './Marker';

type VesselData = IPropsMarker['data'];

export function createVesselUpdates(initial: VesselData) {
    let data = initial;
    const listeners = new Set<() => void>();
    return {
        getSnapshot: () => data,
        subscribe(listener: () => void) {
            listeners.add(listener);
            return () => { listeners.delete(listener); };
        },
        update(next: VesselData) {
            if (next === data) return;
            data = next;
            listeners.forEach(listener => listener());
        }
    };
}

export type VesselUpdates = ReturnType<typeof createVesselUpdates>;

// GPS motion is applied through the map API; dimensions still affect React's SVG.
export function sameVesselAppearance(previous: VesselData, next: VesselData) {
    const previousKeys = Object.keys(previous).filter(key => key !== 'gps');
    const nextKeys = Object.keys(next).filter(key => key !== 'gps');
    return previousKeys.length === nextKeys.length
        && previousKeys.every(key => Object.prototype.hasOwnProperty.call(next, key)
            && previous[key] === next[key])
        && previous.gps?.width === next.gps?.width
        && previous.gps?.length === next.gps?.length;
}
